export const bookingRegistrationTemplate = `
<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office">
  <head>
    <meta charset="UTF-8" />
    <meta content="width=device-width, initial-scale=1" name="viewport" />
    <meta name="x-apple-disable-message-reformatting" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta content="telephone=no" name="format-detection" />
  </head>
  <body
    align="center"
    style="background: white; width: 100%; font-family: verdana, geneva, sans-serif; margin: 0; padding: 0"
  >
    <div style="background: white">
      <div style="background-color: #f7f7f7; height: 34px">
        <div style="color: #cccccc; padding: 10px; margin: 0px; font-size: 12px">
          Deine Reservierung ist eingegangen
        </div>
      </div>
      <div align="center" style="padding-top: 20px">
        <img class="adapt-img" src="{{tenantLogo}}" width="180" />
      </div>
      <div style="margin: 0; padding-top: 20px; padding-bottom: 40px; max-width: 600px; margin: auto">
        <h2 style="margin: 0; font-size: 24px; color: #333333; font-style: normal; font-weight: normal">
          Hallo {{name}},
        </h2>
        <p
          style="
            margin: 0;
            font-size: 16px;
            font-family: verdana, geneva, sans-serif;
            line-height: 24px;
            color: #333333;
            padding-top: 16px;
          "
        >
          deine Reservierung ist bei uns eingegangen und wird geprüft.
        </p>
        <p
          style="
            margin: 0;
            font-size: 16px;
            font-family: verdana, geneva, sans-serif;
            line-height: 24px;
            color: #333333;
            padding-top: 16px;
          "
        >
          Wir geben dir so schnell wie möglich bescheid.
        </p>
      </div>
      <div style="margin: 0; background-color: #f7f7f7; width: 100%; padding-top: 20px; padding-bottom: 20px">
        <h2
          style="
            margin: 0;
            line-height: 36px;
            font-family: arial, 'helvetica neue', helvetica, sans-serif;
            font-size: 24px;
            color: #333333;
            padding-top: 10px;
            font-style: normal;
            font-weight: normal;
          "
        >
          Deine Reservierungsdetails
        </h2>
        {{tenantSpecificPart}}
      </div>
      <div style="padding-top: 20px; padding-bottom: 20px; max-width: 600px; margin: auto">
        <p
          style="margin: 0; padding-top: 10px; padding-bottom: 10px; font-size: 14px; line-height: 21px; color: #333333"
        >
          Dies ist eine Benachrichtigung, um dir mitzuteilen, dass wir deine Reservierung erfolgreich erhalten haben.
          Sobald wir sicherstellen können, dass genügend Kapazität verfügbar ist, werden wir sie bestätigen und dich
          darüber informieren. Falls dies nicht der Fall ist, werden wir dich ebenfalls benachrichtigen. Wir bitten um
          deine Geduld und danken dir für dein Verständnis.
        </p>

        <p
          style="margin: 0; padding-top: 10px; padding-bottom: 10px; font-size: 14px; line-height: 21px; color: #333333"
        >
          Falls du deine Reservierung stornieren möchtest, kannst du diese <a href="{{cancelLink}}">hier</a> stornieren.
        </p>
        <p
          style="margin: 0; padding-top: 10px; padding-bottom: 10px; font-size: 14px; line-height: 21px; color: #333333"
        >
          Du erhälst diese E-Mail, da du eine Online-Reservierung mit xeetr durchgeführt hast.
        </p>
        {{footer}}
      </div>
    </div>
  </body>
</html>
`
